import Vue from 'vue';
import qs from "qs";
import ApiUrl from '../apiurl';
import Permissions from "../permissions.js"
export default {
    namespaced: true,
    state: {
        marketTags: [],
        gainData:[],
    },
    getters: {
        marketTags: (state) => {
            return state.marketTags;
        },
        gainData:(state) =>{
            return state.gainData;
        },
    },

    mutations: {
        setMarketTags(state, newValue) {
          
            Vue.set(state, 'marketTags', [...newValue]);
        },
        setGainData(state,newValue)
        {
            Vue.set(state,'gainData', [...newValue]);
        },
        clearGainData(state){
            Vue.set(state,'gainData', []);
            
        },
        clearMarketTags(state)
        {
            Vue.set(state, 'marketTags', []);
        }
    },
    
    actions: {
       
        async getMarketsByName({commit},{params,handle}){
            try {
                commit('startLoading', null, { root: true });
                
                const rsp = await axios.get(ApiUrl.gain.getmarketsbyname,{params:params});
                if(rsp ) {             
                    if(rsp.data && rsp.data.success)
                    {
                        commit('setMarketTags', rsp.data.result); 
                    }
                   
                    handle&&handle(rsp);
                }
            } catch(e) {
                handle&&handle(e);
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
        },
     async queryGainData({commit,state},{params,handle})
        {
            commit('startLoading', null, { root: true });
            try {
      
                const rsp = await axios.post(ApiUrl.gain.queryGainData+'?'+qs.stringify(params));
                if(rsp && rsp.data && rsp.data.success)
                    {
                        commit('setGainData', rsp.data.result); 
                       //alert(JSON.stringify(state.gainData));
                    }
                   
                handle && handle(rsp);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
        }
       
       
    }

}
